import { OwnerLayout } from "@/components/owner/owner-layout";
import { DataProviderWrapper } from "@/lib/data-provider/context";
import { SupabaseDataProvider } from "@/lib/data-provider/supabase-data-provider";

const supabaseDataProvider = new SupabaseDataProvider();

export function OwnerLayoutWrapper() {
  return (
    <DataProviderWrapper provider={supabaseDataProvider}>
      <OwnerLayout />
    </DataProviderWrapper>
  );
}